import PatchListingProvider from './PatchListing.provider';

export default PatchListingProvider;
